import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NewRelicService {
    private get nr() {
        return typeof window !== 'undefined' ? window.newrelic : undefined;
    }

    setUserId(id: string | null) {
        const nr = this.nr;
        if (!nr) {
            console.warn('New Relic is not initialized.');
            return;
        }

        if (typeof nr.setUserId === 'function') {
            nr.setUserId(id);
        } else {
            //old way
            this.nr?.setCustomAttribute?.('enduser.id', id ?? '');
        }

        const userId = id ?? 'null';
        const message = `the user id is set to ${userId}`;

        nr.log?.(message, {
            level: 'info',
            customAttributes: { userId },
        });
    }

    setAttr(name: string, value: unknown) {
        this.nr?.setCustomAttribute?.(name, value);
    }
}
